<script setup lang="ts">
const localePath = useLocalePath()

const yearStart = 2016
const yearEnd = new Date().getFullYear()

const years = Array.from({ length: yearEnd - yearStart + 1 }, (_, i) => yearEnd - i)

function getYearPath(year: number) {
  return localePath({ name: 'investorRelations-financialDocuments-presentationsWebcasts-year', params: { year } })
}
</script>

<template>
  <div class="FacetedExplorer">
    <div class="GpcMenuWrapper">
      <ul class="GpcMenu FacetedNavigation">
        <li class="GpcMenuCategory">
          <NuxtLink class="GpcMenuCategoryTitle"
                    :to="localePath('investorsRelations-financialDocuments-presentationsWebcasts')">
            {{ $t('navigation.presentationsWebcasts.name') }}
          </NuxtLink>
          <ul>
            <li v-for="year in years"
                :key="year"
                class="GpcMenuItem CFVID38">
              <NuxtLink class="GpcItemTitle"
                        :to="getYearPath(year)">
                {{ year }}
              </NuxtLink>
            </li>
          </ul>
        </li>
      </ul>
      <div class="Nc5c98a45f1ea401cb0f0b008a77b83f7 lienPresentation">
        <NuxtLink class="GpcMenuCategoryTitle"
                  :to="localePath('newsEvents-pressReleases')">
          {{ $t('navigation.pressReleases.name') }}
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
